module.exports = __webpack_public_path__ + "static/media/download.02a207ac.svg";